<template>
    <div class="body">
        <!-- 导航栏 -->
        <mslNav></mslNav>
        <!-- banner -->
        <div class="banner">
            <div class="item">
                <div class="title">我们是</div>
                <div class="intro">德国曼稣勒（中国）权利中心</div>
                <div class="intro">曼稣勒环境科技（上海）有限公司</div>
            </div>
            <div class="item mt_32">
                <div class="title">我们在</div>
                <div class="intro">中国（上海）自由贸易试验区富特西一路139号1号楼第一层101室</div>
            </div>
            <div class="item mt_32">
                <div class="title">邮政编码</div>
                <div class="intro">200131</div>
            </div>
        </div>
        <!-- 留言咨询 -->
        <div class="msg_area">
            <mslMsg></mslMsg>
        </div>
        <!-- 期待你的加入-->
        <div class="hope">
            <div class="h_header">
                <div class="title">期待你的加入</div>
                <div class="intro">欢迎你立刻咨询或留言加入我们的团队</div>
            </div>
            <div class="img">
<!--                <img src="../assets/images/contactus_map.png" alt="">-->
                <div id="allmap" class="allmap"></div>
            </div>
        </div>
        <!-- 底部 -->
        <mslFooter></mslFooter>
    </div>
</template>

<script>
    import { map, baseInfo } from '../api/common.js'
    import myMap  from '../utils/BMap.js'
    export default {
        name: "contact",
        data() {
            return {
                baseInfo: {},
                companyInfo: [],
                logo_img: require('../assets/mapLogo.png'),
                // activeIndex: 4,
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.getMapInfo();
            })
            this.getBaseInfo();
        },
        methods: {
            getBaseInfo () {
                try {
                    baseInfo().then(res => {
                        if(res.code == 1) {
                            this.baseInfo = res.data;
                            console.log(this.baseInfo);
                        }
                    })
                } catch {
                    this.$message.error('获取数据失败，请刷新')
                }
            },
            getPointsCenter(lonlatarr) {
                var total = lonlatarr.length;
                var X = 0;
                var Y = 0;
                var Z = 0;
                lonlatarr.forEach(item => {
                    item.longitude = item.longitude || item.lng
                    item.latitude = item.latitude || item.lat
                    var lon = (item.longitude * Math.PI) / 180;
                    var latitude = (item.latitude * Math.PI) / 180;
                    var x, y, z;
                    x = Math.cos(latitude) * Math.cos(lon);
                    y = Math.cos(latitude) * Math.sin(lon);
                    z = Math.sin(latitude);
                    X += x;
                    Y += y;
                    Z += z;
                });

                X = X / total;
                Y = Y / total;
                Z = Z / total;

                var Lon = Math.atan2(Y, X);
                var Hyp = Math.sqrt(X * X + Y * Y);
                var Lat = Math.atan2(Z, Hyp);
                let lon = (Lon * 180) / Math.PI,
                    lat = (Lat * 180) / Math.PI;
                return {
                    lon,
                    lat,
                    str: `${lon},${lat}`
                };
            },

            getMapInfo() {
                try {
                    map().then(res => {
                        if (res.code == 1) {
                            this.companyInfo = res.data.shopList;
                            // this.getMap();
                            this.initMap();
                        }
                    })
                } catch {
                    this.$message.error('加载数据失败，请刷新');
                }
            },
          initMap() {
            myMap.initTDMap().then((TDMap) => {
              //初始化地图对象
              let map = new TMap("allmap");

              //允许鼠标滚轮缩放地图
              map.enableHandleMouseScroll();
              let arr = []
              let centerArr = []
              var markerInfoWin = new TInfoWindow();
              if (this.companyInfo && this.companyInfo.length > 0) {
                this.companyInfo.forEach((item, index) => {
                  let _item = item;
                  // 经纬度计算
                  let idot = _item.position.indexOf(',');
                  let lat = Number(_item.position.substring(0, idot)); // 纬度
                  let lon = Number(_item.position.substring(idot + 1, _item.position.length)); // 经度
                  // all经纬度
                  centerArr.push({
                    longitude: lon,
                    latitude: lat
                  })
                  // 各个地点
                  var icon = new TIcon("https://sumfen-oss.oss-cn-shenzhen.aliyuncs.com/msl/images/point.png",new TSize(30,35),{anchor:new TPixel(9,27)});
                  var marker = new TMarker(new TLngLat(lon, lat),{icon:icon});

                  arr.push(marker)
                  // 将标注添加到地图中
                  arr.forEach(citem => {
                    map.addOverLay(citem)
                    TEvent.addListener(citem, 'click', function (e) {
                      // 弹窗模版
                      const sContent = '<div class="info_box">\n' +
                          '    <div class="i_title" style="font-size: 16px; color: #4D4D4D; font-weight: 600;" v-if="_item.company">'+ item.company +'</div>\n' +
                          '    <div class="intro" style="font-size: 14px; color: #4D4D4D; margin-top: 10px;" v-if="_item.contacts">联系人： ' + item.contacts + '</div>\n' +
                          '    <div class="intro" style="font-size: 14px; color: #4D4D4D; margin-top: 10px;" v-if="_item.gcontact_number">联系方式： ' + item.contact_number + '</div>\n' +
                          '    <div class="intro" style="font-size: 14px; color: #4D4D4D; margin-top: 10px;" v-if="_item.fax">传真： ' + item.fax + '</div>\n' +
                          '    <div class="intro" style="font-size: 14px; color: #4D4D4D; margin-top: 10px;" v-if="_item.address">店铺地址： ' + item.address + '</div>\n' +
                          '</div>';

                      // 相对于点偏移的位置
                      markerInfoWin.setLabel(sContent);
                      markerInfoWin.setWidth(300);
                      markerInfoWin.setHeight(100);
                      markerInfoWin.setLngLat(citem.getLngLat());
                      map.addOverLay(markerInfoWin);
                    });
                  })

                })
              }
              // // 所有点中心
              let center = this.getPointsCenter(centerArr)
              //设置显示地图的中心点和级别
              map.centerAndZoom(new TLngLat(center.lon, center.lat),5);

              return;
            })
          },

            getMap() {
                myMap.initBMap().then((BaiduMap) => {
                    // 百度地图API功能
                    // var map = new BaiduMap.Map("allmap");    // 创建Map实例
                    // map.centerAndZoom(new BaiduMap.Point(116.404, 39.915), 11);  // 初
                    let map = new BaiduMap.Map('allmap'); // 创建地图实例
                    map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
                    let arr = []
                    let centerArr = []
                    let infoArr = []
                    if (this.companyInfo && this.companyInfo.length > 0) {
                        this.companyInfo.forEach((item, index) => {
                            let _item = item;
                            // 经纬度计算
                            let idot = _item.position.indexOf(',');
                            let lat = Number(_item.position.substring(0, idot)); // 纬度
                            let lon = Number(_item.position.substring(idot + 1, _item.position.length)); // 经度
                            // all经纬度
                            centerArr.push({
                                longitude: lon,
                                latitude: lat
                            })

                            // 各个地点
                            // let myIcon = new BaiduMap.Icon(this.logo_img, new BaiduMap.Size(200, 72));
                            let myPoint = new BaiduMap.Point(lon, lat)
                            let markerTemp = new BaiduMap.Marker(myPoint)
                            arr.push(markerTemp)
                            // 将标注添加到地图中
                            arr.forEach(item => {
                                map.addOverlay(item)
                            })
                            let html = '<div class="info_box">\n' +
                                '    <div class="i_title" style="font-size: 16px; color: #4D4D4D; font-weight: 600;" v-if="_item.company">'+ _item.company +'</div>\n' +
                                '    <div class="intro" style="font-size: 14px; color: #4D4D4D; margin-top: 10px;" v-if="_item.contacts">联系人： ' + _item.contacts + '</div>\n' +
                                '    <div class="intro" style="font-size: 14px; color: #4D4D4D; margin-top: 10px;" v-if="_item.contact_number">联系方式： ' + _item.contact_number + '</div>\n' +
                                '    <div class="intro" style="font-size: 14px; color: #4D4D4D; margin-top: 10px;" v-if="_item.fax">传真： ' + _item.fax + '</div>\n' +
                                '    <div class="intro" style="font-size: 14px; color: #4D4D4D; margin-top: 10px;" v-if="_item.address">店铺地址： ' + _item.address + '</div>\n' +
                                '</div>';
                            // 信息窗
                            let opts = {
                                boxStyle:{
                                    width: "270px"
                                }
                            }
                            let infoWindow = new BaiduMap.InfoWindow(html, opts);  // 创建信息窗口对象
                            markerTemp.addEventListener("click", function () {
                                map.openInfoWindow(infoWindow, myPoint); //开启信息窗口
                            });
                        })
                    }

                    // // 所有点中心
                    let center = this.getPointsCenter(centerArr)
                    // 创建中心点坐标
                    let point = new BaiduMap.Point(center.lon, center.lat);
                    console.log(point, 'point');
                    // 初始化地图，设置中心点坐标和地图级别
                    map.centerAndZoom(point, 5)
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .allmap {
        width: 100%;
        height: 386px;
    }
    .body {
        width: 100%;
        background-color: #fafafa;

        /* banner */
        .banner {
            width: 100%;
            padding: 32px;
            box-sizing: border-box;
            background: #fff url("../assets/images/contactus.png") no-repeat center center;
            background-size: 100% 100%;
            .item {
                width: 100%;
                .title {
                    font-size: 20px;
                    font-family: PingFang SC;
                    font-weight: bold;
                    line-height: 24px;
                    color: #262626;
                }
                .intro {
                    margin-top: 4px;
                    font-size: 12px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    line-height: 18px;
                    color: #8C8C8C;
                }
            }
            .mt_32 {
                margin-top: 32px;
            }
        }

        /* 留言咨询 */
        .msg_area {
            padding: 16px;
            box-sizing: border-box;
        }

        /* 期待你的加入 */
        .hope {
            padding: 24px 0;
            .title {
                font-size: 20px;
                font-family: PingFang SC;
                font-weight: bold;
                line-height: 24px;
                color: #262626;
            }
            .intro {
                margin-top: 4px;
                font-size: 12px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 18px;
                color: #8C8C8C;
            }
            .img {
                width: 100%;
                height: 100%;
                padding: 24px 16px;
                box-sizing: border-box;
                overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
</style>
